var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"daily-check-in-view",attrs:{"fluid":""}},[_c('h1',{staticClass:"text-h5 font-weight-medium mb-2"},[_vm._v("Daily Check-In")]),_c('DailyCheckInDisclaimer'),_c('DailyCheckInSettingsForm')],1)}
var staticRenderFns = []

export { render, staticRenderFns }